<script lang="ts">
    export let height = "40px"
    export let width = "26px"
    export let delay: number = 0
</script>

<svg
    version="1.1"
    x="0px"
    y="0px"
    {width}
    {height}
    viewBox="411.5 21.167 331 534"
    enable-background="new 411.5 21.167 331 534"
    xml:space="preserve"
    style="--delay: {delay}ms"
>
    <path
        fill="#E63946"
        class="marker"
        stroke-width="18"
        stroke-linecap="butt"
        d="M577.432,552.209c-12.084-59.34-33.407-108.732-59.22-154.5
        c-19.148-33.949-41.331-65.293-61.856-98.209c-6.852-10.99-12.766-22.602-19.349-34.007
        c-13.165-22.807-23.839-49.252-23.161-83.553c0.662-33.515,10.355-60.398,24.334-82.381
        c22.989-36.156,61.496-65.797,113.163-73.586c42.246-6.369,81.854,4.392,109.939,20.815c22.951,13.421,40.728,31.35,54.236,52.479
        c14.103,22.053,23.813,48.106,24.626,82.088c0.418,17.411-2.432,33.533-6.449,46.908c-4.063,13.537-10.6,24.853-16.416,36.938
        c-11.354,23.594-25.587,45.213-39.872,66.842c-42.548,64.432-82.484,130.139-99.972,220.176L577.432,552.209z"
    />
    <circle class="fade-in" fill="#9c2831" cx="576.999" cy="182.834" r="81.058" />
</svg>

<style>
.marker {
  stroke: white;
}

svg {
  opacity: 0;
  animation-delay: var(--delay);
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  animation-fill-mode: forwards;
}

@keyframes fadeInOpacity {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
